import React, { CSSProperties, useEffect, useLayoutEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import classNames from "classnames";
import Masthead from "components/Masthead";
import MainContent from "components/MainContent";
import AppSideNav from "components/SideNav/AppSideNav";
import { GameNav } from "@ugitgud/legos/components/nav/GameNav/GameNav";
import { AppRoutes } from "@ugg/shared/routes/app-routes";
import { BannerContainer } from "@ugitgud/legos/components/banner/BannerContainer";
import { HIGHLIGHTS_CTA_ID, HighlightsBanner } from "@ugitgud/legos/components/banner/HighlightsBanner";
import { useBanner } from "@ugitgud/legos/hooks/useBanner";

// For login and signup pages we don't want to display sideNav or Masthead
function isAccountPage(pathname: string) {
  const accountPages: string[] = [
    AppRoutes.SIGNUP,
    AppRoutes.LOGIN,
    AppRoutes.RECOVER_ACCOUNT,
    AppRoutes.RESET_PASSWORD,
    AppRoutes.VERIFICATION,
  ];
  return accountPages.includes(pathname);
}

function isPremiumPage(pathname: string) {
  return pathname.match(/^\/boost\//);
}

const AppLayout = () => {
  const location = useLocation();
  const history = useHistory();
  const [sideNavOpen, setSideNavOpen] = useState(false);
  const { open: isBannerOpen, setBannerOpen } = useBanner(HIGHLIGHTS_CTA_ID);
  const isLanding = location.pathname === AppRoutes.HOME;

  useEffect(() => {
    if (location.pathname !== location.pathname.toLowerCase()) {
      history.replace(location.pathname.toLowerCase() + location.search);
    }
  }, [location.pathname]);

  const mastheadHeightVarValue = `calc(65px + var(--game-nav-height) + ${isBannerOpen ? "48px" : "0px"})`;
  const mastheadHeightVar = {
    "--masthead-height": mastheadHeightVarValue,
  } as unknown as CSSProperties;
  const topPositionStyles: CSSProperties = isBannerOpen ? { top: `calc(var(--game-nav-height) + var(--banner-height))` } : {};

  useLayoutEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--masthead-height", mastheadHeightVarValue);
  }, [mastheadHeightVarValue]);

  return (
    <div
      className={classNames(
        "max-w-[100%]",
        "router-container", // DO NOT REMOVE 'router-container' class. REQUIRED FOR ADS!!!!
      )}
      style={mastheadHeightVar}
    >
      <div className="fixed top-0 left-0 w-full z-[999] transition-[height]">
        <BannerContainer ctaId={HIGHLIGHTS_CTA_ID} open={isBannerOpen} className="h-[48px]">
          {(props) => {
            return <HighlightsBanner url="/app" {...props} onClose={() => setBannerOpen(false)} utmSource="uggswbanner" />;
          }}
        </BannerContainer>
        <GameNav selectedGame="lol" />
        {!isAccountPage(location.pathname) && <Masthead sideNavOpen={sideNavOpen} setSideNavOpen={setSideNavOpen} />}
      </div>
      <div
        id="page-content"
        className={classNames("flex transition-[margin-top]", {
          "sm:mt-[calc(var(--masthead-height) - 65px)]": isLanding,
          "mt-[var(--masthead-height)]": !isLanding,
        })}
      >
        {/* DO NOT REMOVE 'page-content' id. REQUIRED FOR ADS!!!!  */}
        {!isAccountPage(location.pathname) && !isPremiumPage(location.pathname) && (
          <AppSideNav open={sideNavOpen} setOpen={setSideNavOpen} style={topPositionStyles} />
        )}
        <div className="w-full">
          {/* DO NOT REMOVE DIV. REQUIRED FOR ADS!!!!  */}
          <MainContent />
        </div>
      </div>
    </div>
  );
};

export default AppLayout;
